import { dawnFlowEdgeModel, dawnFlowModel } from "./dawnFlowModel";
import { AuditTypeEnum, FlowNodeStateEnum, NodeCountersignOrderEnum, NodeCountersignWayEnum, NodeTypeEnum } from "./nodeEnum";
import { conditionCountersignNodeModel, conditionNodeModel, countersignNodeModel, decisionNodeModel, ordinaryNodeModel } from "./nodeModel";
interface verifyModel {
  verifyResult: boolean;
  verifyInfo: string;
}

interface countersignNodeVerifyModel {
  result: boolean;
  info: string;
  auditKey: string | number | null;
}

//验证流程数据完整性
export const VerifyFlowData = function (flowJsonData: string): verifyModel {
  const flowData = JSON.parse(flowJsonData) as dawnFlowModel;
  if (!flowData) {
    return {
      verifyResult: false,
      verifyInfo: '流程数据不能为空',
    };
  }
  if (!flowData.nodes || flowData.nodes.length === 0) {
    return {
      verifyResult: false,
      verifyInfo: '未添加任何流程节点',
    };
  }
  if (!flowData.edges || flowData.edges.length === 0) {
    return {
      verifyResult: false,
      verifyInfo: '流程节点未确定流转关系',
    };
  }
  if (!flowData.nodes.some(node => node.type === NodeTypeEnum.InputNode)) {
    return {
      verifyResult: false,
      verifyInfo: '流程必须包含一个开始节点',
    };
  }
  if (!flowData.nodes.some(node => node.type === NodeTypeEnum.OutputNode)) {
    return {
      verifyResult: false,
      verifyInfo: '流程必须包含一个归档节点',
    };
  }
  if (!flowData.nodes.some(node => node.type !== NodeTypeEnum.InputNode && node.type !== NodeTypeEnum.OutputNode)) {
    return {
      verifyResult: false,
      verifyInfo: '流程必须包含一个非开始节点或归档节点',
    };
  }

  if (flowData.nodes.filter(node => node.type === NodeTypeEnum.InputNode).length > 1) {
    return {
      verifyResult: false,
      verifyInfo: '流程数据中只能包含一个开始节点',
    };
  }
  if (flowData.nodes.filter(node => node.type === NodeTypeEnum.OutputNode).length > 1) {
    return {
      verifyResult: false,
      verifyInfo: '流程数据中只能包含一个归档节点',
    };
  }


  // 验证各节点必填项
  for (const node of flowData.nodes) {
    // 排除验证开始节点和归档节点
    if (node.type !== NodeTypeEnum.InputNode && node.type !== NodeTypeEnum.OutputNode) {
      // 验证普通节点
      if (node.type === NodeTypeEnum.OrdinaryNode) {
        const nodeModel = node.data as ordinaryNodeModel;
        if (!nodeModel.auditKey || nodeModel.auditKey.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置审核信息',
          };
        }
      }
      // 验证会签节点
      if (node.type === NodeTypeEnum.CountersignNode) {
        const nodeModel = node.data as countersignNodeModel;
        if (!nodeModel.auditKey || nodeModel.auditKey.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置审核信息',
          };
        }
      }

      // 验证条件会签节点
      if (node.type === NodeTypeEnum.ConditionCountersignNode) {
        const nodeModel = node.data as conditionCountersignNodeModel;
        if (!nodeModel.auditKey || nodeModel.auditKey.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置审核信息',
          };
        }
        if (!nodeModel.conditionValue || nodeModel.conditionValue.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置流转条件',
          };
        }
      }

      // 验证决策节点
      if (node.type === NodeTypeEnum.DecisionNode) {
        const nodeModel = node.data as decisionNodeModel;
        if (!nodeModel.auditKey || nodeModel.auditKey.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置审核信息',
          };
        }
        if (!nodeModel.conditionValue || nodeModel.conditionValue.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置流转条件',
          };
        }
      }

      // 验证条件节点
      if (node.type === NodeTypeEnum.ConditionNode) {
        const nodeModel = node.data as conditionNodeModel;
        if (!nodeModel.auditKey || nodeModel.auditKey.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置审核信息',
          };
        }
        if (!nodeModel.conditionValue || nodeModel.conditionValue.length === 0) {
          return {
            verifyResult: false,
            verifyInfo: '节点【' + nodeModel.nodeName + '】未设置流转条件',
          };
        }
      }

    }
  }

  // 验证流转关系的节点是否存在
  for (const node of flowData.nodes) {
    if (node.type === NodeTypeEnum.InputNode) {
      const ret = sourceEdgeExists(flowData, node);
      if (!ret.verifyResult) {
        return ret;
      }
    }
    else if (node.type === NodeTypeEnum.OutputNode) {
      const ret = targetEdgeExists(flowData, node);
      if (!ret.verifyResult) {
        return ret;
      }
    }
    else {
      const retSource = sourceEdgeExists(flowData, node);
      if (!retSource.verifyResult) {
        return retSource;
      }
      const retTarget = targetEdgeExists(flowData, node);
      if (!retTarget.verifyResult) {
        return retTarget;
      }
    }
  }

  if (!flowData.position) {
    return {
      verifyResult: false,
      verifyInfo: '流程位置不能为空',
    };
  }
  if (!flowData.zoom) {
    return {
      verifyResult: false,
      verifyInfo: '流程缩放比例不能为空',
    };
  }
  if (!flowData.viewport) {
    return {
      verifyResult: false,
      verifyInfo: '流程视口不能为空',
    };
  }
  return {
    verifyResult: true,
    verifyInfo: '验证通过',
  };
}

//验证节点是否有流转关系--源边是否存在
const sourceEdgeExists = function (flowData: dawnFlowModel, node: any): verifyModel {

  // 条件会签节点、条件节点、决策节点验证源边
  if (node.type === NodeTypeEnum.ConditionCountersignNode || node.type === NodeTypeEnum.ConditionNode || node.type === NodeTypeEnum.DecisionNode) {
    const edgesList = flowData.edges.filter(edge => edge.source === node.id);

    const conditionTypeList = edgesList.map((item) => {
      return item.data.condition;
    });
    const noConditionEdge = node.data.conditionValue.filter(
      (item: any) => !conditionTypeList.includes(item)
    );
    if (noConditionEdge.length > 0) {
      let msg = '节点【' + node.data.nodeName + '】未设置流转关系<br/>';
      for (const item of noConditionEdge) {
        msg += '流转条件【' + item + '】未设置流转关系<br/>';
      }
      return {
        verifyResult: false,
        verifyInfo: msg,
      };
    }
  }

  else {
    const sourceNodeExists = flowData.edges.some(edge => edge.source === node.id);
    if (!sourceNodeExists && (node.type !== NodeTypeEnum.SpLane && node.type !== NodeTypeEnum.CzLane)) {
      return {
        verifyResult: false,
        verifyInfo: '节点【' + node.data.nodeName + '】未确定流转关系',
      };
    }
    return {
      verifyResult: true,
      verifyInfo: '验证通过',
    };
  }
  return {
    verifyResult: true,
    verifyInfo: '验证通过',
  };
}

//验证节点是否有流转关系--目标边是否存在
const targetEdgeExists = function (flowData: dawnFlowModel, node: any): verifyModel {
  const targetNodeExists = flowData.edges.some(edge => edge.target === node.id);
  if (!targetNodeExists && (node.type !== NodeTypeEnum.SpLane && node.type !== NodeTypeEnum.CzLane)) {
    return {
      verifyResult: false,
      verifyInfo: '节点【' + node.data.nodeName + '】未确定流转关系',
    };
  }
  return {
    verifyResult: true,
    verifyInfo: '验证通过',
  };
}

//获取开始节点
export const getStartNode = function (flowData: dawnFlowModel): any {
  return flowData.nodes.find(node => node.type === NodeTypeEnum.InputNode);
}

//获取归档节点
export const getEndNode = function (flowData: dawnFlowModel): any {
  return flowData.nodes.find(node => node.type === NodeTypeEnum.OutputNode);
}

//验证是否为开始节点
export const verifyStartNode = function (flowData: dawnFlowModel, currentNodeId: string): boolean {
  return flowData.nodes.some(node => node.type === NodeTypeEnum.InputNode && node.id === currentNodeId);
}

//验证是否为归档节点
export const verifyEndNode = function (flowData: dawnFlowModel, currentNodeId: string): boolean {
  return flowData.nodes.some(node => node.type === NodeTypeEnum.OutputNode && node.id === currentNodeId);
}

//获取下一个节点
export const getNextNodes = function (flowData: dawnFlowModel, node: any): any[] {
  return flowData.edges.filter(edge => edge.source === node.id).map(edge => flowData.nodes.find(n => n.id === edge.target));
}

//获取上一个节点
export const getPreviousNode = function (flowData: dawnFlowModel, node: any): any[] {
  return flowData.edges.filter(edge => edge.target === node.id).map(edge => flowData.nodes.find(n => n.id === edge.source));
}

//获取会签节点审核键值
export const getCountersignAuditKey = function (node: any, prvExamineId: string | number): countersignNodeVerifyModel {

  // 验证节点是否为会签节点
  if (node.type !== NodeTypeEnum.CountersignNode) {
    return {
      result: false,
      info: '节点【' + node.data.label + '】不是会签节点',
      auditKey: '',
    };
  }

  // 审核类型为指定用户
  if (node.data?.auditType === AuditTypeEnum.appointUser) {

    //只需任意一人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.EitherReviewerExamine) {
      return {
        result: true,
        info: '',
        auditKey: node.data?.userId[0] || '',
      };
    }

    //需所有审批人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.AllReviewerExamine) {
      //按顺序审批
      if (node.data?.countersignOrder === NodeCountersignOrderEnum.OrderAsc) {
        const nextId = getNextId(node.data?.userId, prvExamineId);
        if (!nextId) {
          return {
            result: false,
            info: '节点【' + node.data.label + '】审核人已审核完',
            auditKey: '',
          };
        }
        else {
          return {
            result: true,
            info: '',
            auditKey: nextId,
          };
        }
      }
    }
  }


  // 审核类型为指定部门
  if (node.data?.auditType === AuditTypeEnum.appointDepartment) {

    //只需任意一人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.EitherReviewerExamine) {
      return {
        result: true,
        info: '',
        auditKey: node.data?.departmentId[0] || '',
      };
    }

    //需所有审批人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.AllReviewerExamine) {
      //按顺序审批
      if (node.data?.countersignOrder === NodeCountersignOrderEnum.OrderAsc) {
        const nextId = getNextId(node.data?.departmentId, prvExamineId);
        if (!nextId) {
          return {
            result: false,
            info: '节点【' + node.data.label + '】部门审核人已审核完',
            auditKey: '',
          };
        }
        else {
          return {
            result: true,
            info: '',
            auditKey: nextId,
          };
        }
      }
    }
  }

  // 审核类型为指定岗位
  if (node.data?.auditType === AuditTypeEnum.appointPost) {

    //只需任意一人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.EitherReviewerExamine) {
      return {
        result: true,
        info: '',
        auditKey: node.data?.postId[0] || '',
      };
    }

    //需所有审批人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.AllReviewerExamine) {
      //按顺序审批
      if (node.data?.countersignOrder === NodeCountersignOrderEnum.OrderAsc) {
        const nextId = getNextId(node.data?.postId, prvExamineId);
        if (!nextId) {
          return {
            result: false,
            info: '节点【' + node.data.label + '】岗位审核人已审核完',
            auditKey: '',
          };
        }
        else {
          return {
            result: true,
            info: '',
            auditKey: nextId,
          };
        }
      }
    }
  }

  // 审核类型为指定岗位
  if (node.data?.auditType === AuditTypeEnum.appointRole) {

    //只需任意一人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.EitherReviewerExamine) {
      return {
        result: true,
        info: '',
        auditKey: node.data?.roleId[0] || '',
      };
    }

    //需所有审批人审批
    if (node.data?.countersignWay === NodeCountersignWayEnum.AllReviewerExamine) {
      //按顺序审批
      if (node.data?.countersignOrder === NodeCountersignOrderEnum.OrderAsc) {
        const nextId = getNextId(node.data?.roleId, prvExamineId);
        if (!nextId) {
          return {
            result: false,
            info: '节点【' + node.data.label + '】角色审核人已审核完',
            auditKey: '',
          };
        }
        else {
          return {
            result: true,
            info: '',
            auditKey: nextId,
          };
        }
      }
    }
  }

  return {
    result: false,
    info: '',
    auditKey: '',
  };
}

//获取两个节点之间的所有节点
export const getBetweenNodes = function (flowData: dawnFlowModel, startNode: any, endNode: any): any[] {
  const betweenNodes = flowData.edges.filter(edge => edge.source === startNode.id && edge.target === endNode.id).map(edge => flowData.nodes.find(n => n.id === edge.target));
  return betweenNodes;
}

//设置节点审核状态
export const setNodeAuditStatus = function (node: any, status: FlowNodeStateEnum): any {
  if (status === FlowNodeStateEnum.AuditPass) {
    node.class = node.class.split(' ')[0] + ' ' + 'agreeBackColor'
    return node;
  }
  if (status === FlowNodeStateEnum.InExamine) {
    node.class = node.class.split(' ')[0] + ' ' + 'inExamineBackColor'
    return node;
  }
  if (status === FlowNodeStateEnum.AuditRefuse) {
    node.class = node.class.split(' ')[0] + ' ' + 'disagreeBackColor'
    return node;
  }
  if (status === FlowNodeStateEnum.AuditDismissal) {
    node.class = node.class.split(' ')[0] + ' ' + 'rejectBackColor'
    return node;
  }
  return node;
}

//设置边审核状态
export const setEdgeAuditStatus = function (flowData: dawnFlowModel, startNode: string, endNode: string, status: FlowNodeStateEnum): any {
  for (let edge of flowData.edges) {
    edge = edge as dawnFlowEdgeModel;
    edge.style = edge.style || {};
    if (edge.source === startNode && edge.target === endNode) {

      if (status === FlowNodeStateEnum.AuditPass) {
        edge.style.stroke = '#16b777'
        return edge;
      }
      if (status === FlowNodeStateEnum.InExamine) {
        edge.style.stroke = '#31bdec'
        return edge;
      }
      if (status === FlowNodeStateEnum.AuditRefuse) {
        edge.style.stroke = 'red'
        return edge;
      }
      if (status === FlowNodeStateEnum.AuditDismissal) {
        edge.style.stroke = '#ffb800'
        return edge;
      }
    }
  }
}

//获取当前时间
export const getData = function (): string {
  const now = new Date();
  return now.toLocaleString();
}

//获取下一个审批人id
function getNextId<T extends number | string>(
  items: T[],
  currentId: number | string
): number | string | null {
  if (currentId === null || currentId === undefined) {
    return items[0];
  }
  const currentIndex = items.findIndex(item => item === currentId);

  if (currentIndex === -1 || currentIndex === items.length - 1) {
    return null; // 未找到或已是最后一个
  }
  return items[currentIndex + 1];

}

